import { render, staticRenderFns } from "./voucher-sale.vue?vue&type=template&id=63a3d940&scoped=true&"
import script from "./voucher-sale.vue?vue&type=script&lang=js&"
export * from "./voucher-sale.vue?vue&type=script&lang=js&"
import style0 from "./voucher-sale.vue?vue&type=style&index=0&id=63a3d940&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a3d940",
  null
  
)

export default component.exports